import { render, staticRenderFns } from "./FulfillmentReasons.vue?vue&type=template&id=68df0f7b&scoped=true&"
import script from "./FulfillmentReasons.vue?vue&type=script&lang=js&"
export * from "./FulfillmentReasons.vue?vue&type=script&lang=js&"
import style0 from "./FulfillmentReasons.vue?vue&type=style&index=0&id=68df0f7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68df0f7b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2983364112/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68df0f7b')) {
      api.createRecord('68df0f7b', component.options)
    } else {
      api.reload('68df0f7b', component.options)
    }
    module.hot.accept("./FulfillmentReasons.vue?vue&type=template&id=68df0f7b&scoped=true&", function () {
      api.rerender('68df0f7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/FulfillmentReasons.vue"
export default component.exports